import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import {
    KYC_MODAL_STEP_INIT,
    KYC_MODAL_STEP_IN_PROGRESS,
    KYC_MODAL_STEP_ERROR
} from '../../../services/kyc/constants';

import { reset } from '../../../services/kyc/actions';

import KycStep1 from './KycStep1';
import KycStep2 from './KycStep2';
import KycStepError from './KycStepError';

import { KycModalContainer } from './KycModalStyle';

const KycModal = ({ useCase, reset }) => {
    const [step, setStep] = useState(KYC_MODAL_STEP_INIT);
    const [errorType, setErrorType] = useState(null);

    useEffect(() => {
        return () => {
            reset();
        };
    }, []);

    return (
        <KycModalContainer>
            {step === KYC_MODAL_STEP_INIT && (
                <KycStep1 setStep={setStep} setErrorType={setErrorType} useCase={useCase} />
            )}
            {step === KYC_MODAL_STEP_IN_PROGRESS && (
                <KycStep2 setStep={setStep} setErrorType={setErrorType} useCase={useCase} />
            )}
            {step === KYC_MODAL_STEP_ERROR && <KycStepError errorType={errorType} />}
        </KycModalContainer>
    );
};

const mapDispatchToProps = {
    reset
};

export default connect(null, mapDispatchToProps)(KycModal);



// WEBPACK FOOTER //
// ./src/components/fraud/kyc/KycModal.js